<template>
    
    <div class='container mb-5'>

        <div v-if="status=='loading'" class="row">
            <div class="col-12 tc py-5">
                <b-spinner variant="primary" label="Carregando..."></b-spinner>
                <p class="mt-3 text-muted">Carregando evento...</p>
            </div>
        </div>

        <div v-if="status=='loaded'"  class='row'>

            <div class="col-12">

                <event-info :event="event"></event-info>

                <router-link v-if="gpxWindowOpen" to="/myregistrations" class="gpx-banner">
                    <span class="gpx-banner-icon">📍</span>
                    <span class="gpx-banner-text">
                        <strong>Envie o Tracklog da sua corrida</strong>
                        <small>Janela de envio aberta — comprove seu percurso</small>
                    </span>
                    <span class="gpx-banner-arrow">→</span>
                </router-link>
                <!-- {{ currentOrder.token }} -->
                <div v-if="event.finish==true && !currentOrder.token && $route.name !='eventnew'">
                    <div class='alert alert-danger'>
                        Inscrições Encerradas
                    </div>
                    <div class="tc mt-4">
                        <p class="mb-2 text-muted">Já está inscrito?</p>
                        <b-button :to="'/myregistrations'" variant="primary">
                            Acesse suas inscrições
                        </b-button>
                    </div>
                </div>

            <div v-else class='row'> 

                <div class="col-12">
                <div v-if="currentStage!='finish'" class='row stage-selector mb-4'>
                    <div class="col-3 tc" @click="goToStage('products-chooser')" :class="{active:currentStage=='products-chooser'}">
                        <div class='stage-number'>1</div>
                        <div class='stage-name'>Selecione suas provas</div>
                    </div>
                    <div class="col-3 tc" @click="goToStage('products-infos')" :class="{active:currentStage=='products-infos', disable:canProductsInfos==false }">
                        <div class='stage-number'>2</div>
                        <div class='stage-name'>Informações dos atletas</div>
                    </div>
                    <div class="col-3 tc" @click="goToStage('identification')" :class="{active:currentStage=='identification', disable:lastCompleteStageIndex<2 }">
                        <div class='stage-number'>3</div>
                        <div class='stage-name'>Identificação</div>
                    </div>
                    <div class="col-3 tc" @click="goToStage('checkout')" :class="{active:currentStage=='checkout',disable:(lastCompleteStageIndex<3 || canProductsInfos==false) }">
                        <div class='stage-number'>4</div>
                        <div class='stage-name'>Pagamento</div>
                    </div>
                </div>

            
                <div v-show="currentStage=='products-chooser'" class='row'>
                    <div class='col-12 col-md-8'>
                        <products-chooser :event='event'></products-chooser>
                        <div class='tc w-100 d-none d-sm-block'>
                            <!-- <b-button v-show="canProductsInfos"  @click=" currentStage='products-infos' " class=' mt-5' size="lg" variant="primary" > Próximo </b-button> -->
                        </div>
                    </div>
                    <div class='col-12 col-md-4' >
                        <div class='sticky-top' style="top: 20px">
                            <shopping-cart-total :canShowCupom="false"> </shopping-cart-total>
                    
                            <div :class="{mobileresume:canProductsInfos}">
                                <b-button v-show="canProductsInfos"  @click=" currentStage='products-infos' " class='w-100 mt-5 ' size="lg" variant="primary" > Próximo </b-button>
                             </div>
                        </div>
                    </div>
                </div>
            
                <div v-show="currentStage=='products-infos'" class='row'>
                     <div class='col-12 col-md-8'>
                            <div class='alert alert-warning'>
                            <p> Se desejar as informações dos integrantes poderão ser preenchidas posteriromente até 2 semanas antes</p>
                                <small> *<b>Atenção</b>, para descontos dos atletas acima de 60 anos ou Pessoa com Deficiência (PCD), os dados devem ser preenchidos agora, e os comprovantes apresentados na retirado do Kit, conforme o regulamento!  </small>
                            </div>
                         <purshase-products-list ref='purchaseProductList'> </purshase-products-list>
                     </div>
                      <div class='col-12 col-md-4'>
                        <div class='sticky-top' style="top: 20px">
                        <shopping-cart-total :canShowCupom="true"> </shopping-cart-total>
                       <div class="mobileresume">
                            
                            <b-button @click="goToStage('identification')" class='w-100 mt-5 ' size="lg" variant="primary" > Próximo </b-button>
                        </div> 
                        </div>

                    </div>
            
                    <div class='tc w-100'>
                        <b-button v-show="canProductsInfos"  @click=" currentStage='products-chooser' " class=' mt-3' size="lg" variant="default" > Voltar </b-button>
                        <!-- <b-button @click="goToStage('identification')" class=' mt-5' size="lg" variant="primary" > Próximo </b-button> -->
                    </div>
                </div>
           
                <div v-if="currentStage=='identification'" class="row" >
                    <div class='col-12 col-md-8'>
                        <identification-info ref='identificationInfo' />
            
                    </div>
                    <div class='col-12 col-md-4 '>
                        <div class='sticky-top' style="top: 20px">
                         <shopping-cart-total :canShowCupom="true"> </shopping-cart-total>
                            <div class="mobileresume">
                                <b-button @click="goToStage('checkout')" class='w-100 mt-5 ' size="lg" variant="primary" > Próximo </b-button>
                            </div>
                        </div>  
                    </div>
                      <div class='tc w-100'>
                           <b-button v-show="canProductsInfos" @click="goToStage('products-infos')"  class=' mt-5' size="lg" variant="default" > Voltar </b-button>
                           <!-- <b-button @click="goToStage('checkout')" class=' mt-5' size="lg" variant="primary" > Próximo </b-button> -->
                        </div>
                </div>


                <div v-show="currentStage=='checkout'" class="row" >
                    <div class='col-12 col-md-8'>

                        <payment-info ref="paymentInfo"/>

                        <div class='tc w-100'>

                            <b-modal ref="modalRegulation" size="lg" id="modal1" title="Regulamento" @ok="giveOkRegulamento">
                                <div class='tl' style="height:70vh;overflow:auto" v-html="event.regulation"></div>
                            </b-modal>
                        </div>

                   
                    </div>
                    <div class='col-12 col-md-4'>
                        <div class='sticky-top' style="top: 20px">
                         <shopping-cart-total :canShowCupom="true"> </shopping-cart-total>
                            <div class="mobileresume">
                                <!-- <b-button @click="goToStage('checkout')" class='w-100 mt-5 ' size="lg" variant="primary" > Próximo </b-button> -->
                                <!-- isNewOrder:{{ isNewOrder }} -->
                                <b-button v-if="okregulamento == false && isNewOrder"  @click="showRegulamentonModal" class=' mt-5 w-100' size="lg" variant="primary" > Ver Regulamento e Finalizar as Inscrição </b-button>
                                <b-button v-if="okregulamento == true || !isNewOrder"  @click="goToStage('finish')" class=' mt-5 w-100' size="lg" variant="primary" > Realizar Pagamento </b-button>
                            </div>
                        </div>
                    </div>
                         <!-- <div class='tc w-100'>
                            <b-button v-show="canProductsInfos" @click="goToStage('identification')"  class=' mt-5' size="lg" variant="default" > Voltar </b-button>
                            <b-button v-if="okregulamento == false"  @click="showRegulamentonModal" class=' mt-5' size="lg" variant="primary" > Ver Regulamento e Finalizar as Inscrição </b-button>
                            <b-button v-if="okregulamento == true"  @click="goToStage('finish')" class=' mt-5' size="lg" variant="primary" > Finalizar as Inscrição </b-button>
                        </div> -->
                </div>

                <div v-if="currentStage=='finish'" class="row">
                    <div class='col-12 col-md-8'>
                           <div v-if=" orderPaymentStatus == 'payed'">
                                <div class='alert alert-success' >
                                    <h5> Pagamento Confirmado! </h5>
                                    <p> Você recebera em breve email com mais instrucões!
                                    <p> Nº da sua ordem é: {{$route.params.order}} </p>
                                    <p> para acessa-la a qualquer momento basta acessar http://largadaesportiva.ajresportes.com.br/{{$route.params.order}} </p>
                                </div>
                        </div>
                    </div>
                </div>
                </div>
            </div> <!-- end if event finish -->
        </div>

        </div>

        <div v-if="status=='error'">
             <b-alert show variant="danger" >
                          Ocorreu um erro!
            </b-alert>
        </div>



    </div>
</template>

<script>
export default {
    data(){
        return {
            okregulamento:false
        }
    },

    created:function(){
        this.$store.dispatch('EventStore/loadEvent',this.$route.params.id);
        
        // const savedStage = window.localStorage.getItem('currentPage');
        // if (savedStage) {
        //     this.currentStage = savedStage;
        // }else{
        //     this.currentStage = "products-chooser";
        // }
        // this.currentStage = "products-chooser";

        
        if( this.$route.params.order ){
            this.$store.dispatch('OrderStore/loadOrderByToken',this.$route.params.order);
        }

        //set currentPage based on infos


    },

    watch:{
        $route:function(){

        },
        currentStage:function(val){
            window.localStorage.setItem('currentPage',val)
            // this.$router.push(val)
        },

        currentOrder:function(val){
           if(val.token){
                this.goToStage('checkout')
            }
        }
    },

    computed:{
        order:function(){
            return this.$store.getters['OrderStore/currentOrder']
        },
        isNewOrder:function(){
            
            return this.$get(this.order,'id',' ').toString().match(/new/g) ? true : false
        },
        orderPaymentStatus:function(){
            return this.$store.getters['OrderStore/currentOrderPaymentStatus']
        },
        currentStage:{
            set:function(val){
                this.$store.commit('ShoppingCartStore/currentStage',val)
            },
            get:function(){
                return this.$store.getters['ShoppingCartStore/currentStage']
            }
        },
        currentStageIndex:function(){
            return this.$store.getters['ShoppingCartStore/currentStageIndex']
        },
        lastCompleteStageIndex:function(){
            return this.$store.getters['ShoppingCartStore/lastCompleteStageIndex']
        },
        event:function(){
                return this.$store.getters['EventStore/eventInfo'];
        },
        // Janela de envio de GPX aberta: habilitada e agora entre abertura/fechamento.
        gpxWindowOpen:function(){
                let e = this.event;
                if( !e || !e.uploadGPX ) return false;
                let now = Date.now();
                let open = e.gpxUploadOpenAt ? new Date(e.gpxUploadOpenAt).getTime() : null;
                let close = e.gpxUploadCloseAt ? new Date(e.gpxUploadCloseAt).getTime() : null;
                if( open && now < open ) return false;
                if( close && now > close ) return false;
                return true;
        },
        status:function(){
                return this.$store.getters['EventStore/status'];
        },
        statusError:function(){
                return this.$store.getters['EventStore/statusError'];
        },
        currentOrder:function(){
            return this.$store.getters['OrderStore/currentOrder'];
        },

        canProductsChooser:function(){
            return true;
        },
        canProductsInfos:function(){
            let purchaseProducts = this.$store.getters['OrderStore/purshaseProductsForCurrentOrder'];
            if(purchaseProducts){
                if(purchaseProducts.length > 0)
                return true
            }
            return false
        },

        canCheckout:function(){

        },
    },

    methods:{

        giveOkRegulamento:function(){
            this.okregulamento = true;
            this.goToStage('finish')
        },

        showRegulamentonModal:async function(){
                //check if forms ok
                let formok = await this.$refs.paymentInfo.formsOk()
                if(formok){
                    //open modal
                    this.$refs.modalRegulation.show();
                }
        },

        goToStage:async function(index){
            if(index=='products-chooser'){
                if(this.canProductsChooser){
                    this.currentStage = index
                }
            }

            if(index=='products-infos'){
                  if(this.canProductsInfos){
                    this.currentStage = index
                }
            }

            if(index=='identification'){
                
                if(!this.canProductsInfos) return false;

                //check if forms ok
                
                let formok = await this.$refs.purchaseProductList.formsOk()
                if(formok){
                    this.currentStage = index
                }
            }

            if(index=='checkout'){
                  if( ! this.canProductsInfos) return false;

                //check if forms ok
                if(this.$refs.identificationInfo){
                    let formok = await this.$refs.identificationInfo.formsOk()
                    if(formok){
                        this.currentStage = index
                    }
                }else{
                    this.currentStage = index
                }
            }
            

            if(index=='finish'){
                //check if forms ok
                let formok = await this.$refs.paymentInfo.placeOrder()
                if(formok){
                    this.currentStage = index
                }
            }
        },

    },

}
</script>

<style lang="stylus">

        .gpx-banner{
            display:flex;
            align-items:center;
            gap:0.9rem;
            margin:1rem 0 1.5rem;
            padding:1rem 1.25rem;
            border-radius:10px;
            background:linear-gradient(90deg, #f39c12, #e67e22);
            color:#fff;
            text-decoration:none;
            box-shadow:0 2px 8px rgba(230,126,34,0.35);
            transition:transform 0.12s ease, box-shadow 0.12s ease;
        }
        .gpx-banner:hover{
            color:#fff;
            transform:translateY(-1px);
            box-shadow:0 4px 14px rgba(230,126,34,0.45);
        }
        .gpx-banner-icon{
            font-size:1.6rem;
            line-height:1;
        }
        .gpx-banner-text{
            flex:1;
            display:flex;
            flex-direction:column;
            line-height:1.3;
        }
        .gpx-banner-text strong{
            font-size:1.05rem;
        }
        .gpx-banner-text small{
            opacity:0.9;
        }
        .gpx-banner-arrow{
            font-size:1.4rem;
        }

        .stage-selector{
            &>div{
                cursor:pointer;
            }
            .stage-number{
                display:inline-block;
                width larg = 50px;
                height:larg;
                background:var(--product-selector-bg-color);
                border-radius:50%;
                line-height: larg;
                color:white;
                font-weight bold;
                font-size:20px;
                // border:3px solid white;

            }
            .stage-name{
                color:gray;
            }

            .disable{
                .stage-number{
                    background gray;
                    opacity:0.5;
                }
            
            }

        }

</style>
